import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getProjectDrawerData } from 'services/app';

export default function useProjectDrawerData(
  projectSlug: string,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    `project-${projectSlug}-drawer-data`,
    () =>
      getProjectDrawerData(projectSlug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
